import { Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { Outlet } from 'react-router-dom';
import { OrganizationTabNavigation } from '../components/organizationTabNavigation';

export const OrganizationPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <GridWrapper>
        <Grid item xs={12} md={6}>
          <MainContentHeader title={t('organization:organizationPage.header')} />
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <OrganizationTabNavigation />
            <Outlet />
          </Paper>
        </Grid>
      </GridWrapper>
    </>
  );
};
